import { Config } from "./config";

const SettingsResource = {
    base: "/api/settings",
    get(callback) {
        Config.Connection()
            .get(this.base)
            .then(r => callback(r.data))
            .catch(err => callback(err.response?.data));
    },
    update(data, callback) {
        Config.Connection()
            .put(this.base, data)
            .then(r => callback(r.data))
            .catch(err => callback(err.response?.data));
    },
    test(callback) {
        Config.Connection()
            .get(`${this.base}/test-smtp`)
            .then(r => callback(r.data))
            .catch(err => callback(err.response?.data));
    },
};
export default SettingsResource;